// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","main":"App_main__nhgh3"};